import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { useNavigate } from "react-router-dom";
import ProfilePictureDetails from "../../components/admin/ProfilePictureDetails";
import Breadcrumbs from "../../components/Breadcrumbs";
import { resetBreadcrum } from "../../redux/reducers/BreadcrumbSlice";
import { useAppSelector } from "../../redux/hooks";
import { UserState } from "../../redux/reducers/UserSlice";
import "../../styles/ViewProfile.scss";
import Utility from "../../utility/Utility";
import ProfileDetailsTranslations from "../../components/admin/ProfileDetailsTranslations";
import { API } from "../../constants/api";
import { ROLE } from "src/constants/role";
import {
  ApiCallWithLoader,
  errorUpdate,
} from "../../redux/reducers/LoaderSlice";

const getUserName = (given: any, last: any) => {
  if (given && last) {
    return given + " " + last;
  }
  return undefined;
};

const UserProfile = () => {
  const userDetails: any = useAppSelector(UserState);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const role = Utility.getUserRole(
    userDetails?.userDetails?.app_metadata?.organizations?.EODB?.groups[0]
  );
  const [gbAdminCounts, setGbAdminCounts] = useState<any>({
    stateCount: "0",
    districtCount: "0",
  });
  const [districtList, setDistrictList] = useState<any>(null);

  const getAddressContentData = (role:string) => {
    let addressData = [{}];
    if(role === ROLE.GLOBAL_ADMIN || role === ROLE.GLOBAL_ADMIN_SUPPORT){
      addressData = [
        {
          title: "myProfile.number_of_state",
          data: gbAdminCounts?.stateCount,
        },
        {
          title: "myProfile.number_of_districts",
          data: gbAdminCounts?.districtCount,
        },
      ];
    } else if (role === ROLE.ADMIN) {
      addressData = [
        {
          title: "state",
          data: userDetails?.userDetails?.user_metadata?.address?.region,
        },
        {
          title: "list_of_district",
          data: districtList,
        },
      ]
    } else if (role === ROLE.ASHA || role === ROLE.ANM) {
      addressData = [
        {
          title: "myProfile.village_slum",
          data: userDetails?.userDetails?.user_metadata?.address
            ?.locality?.split(",")[0],
        },
        {
          title: "myProfile.district_block",
          data: userDetails?.userDetails?.user_metadata?.address
            ?.locality?.split(",")[1],
        },
        {
          title: "myProfile.state",
          data: userDetails?.userDetails?.user_metadata?.address
            ?.region,
        },
        {
          title: "myProfile.pinCode",
          data: userDetails?.userDetails?.user_metadata?.address
            ?.postal_code,
        },
      ]
    }
    return addressData;
  }

  const getAssignLocationContentData = (role:string) => {
    let locationData = [{}];
    if (role === ROLE.ASHA) {
      locationData = [
        {
          title: "myProfile.village",
          data: [
            userDetails?.userDetails?.user_metadata?.address
              ?.locality?.split(",")[0],
          ],
        },
        {
          title: "myProfile.subCenter",
          data: [
            userDetails?.userDetails?.user_metadata?.organizations?.EODB
              ?.sub_center,
          ],
        },
        {
          title: "myProfile.upch_phc",
          data: [
            userDetails?.userDetails?.user_metadata?.organizations?.EODB
              ?.uphcPhc,
          ],
        },
      ]
    }else if (role === ROLE.ANM) {
      locationData = [
        {
          title: "myProfile.upch_phc",
          data: [
            userDetails?.userDetails?.user_metadata?.organizations?.EODB
              ?.uphcPhc,
          ],
        },
      ]
    }
    return locationData;
  }

  useEffect(() => {
    dispatch(resetBreadcrum());
    if (role === ROLE.GLOBAL_ADMIN || role === ROLE.GLOBAL_ADMIN_SUPPORT) {
      const getCounts = async () => {
        try {
          const stateRequestDetails = {
            url: API.STATE_COUNT,
            method: "GET",
          };
          const districtRequestDetails = {
            url: API.DISTRICT_COUNT,
            method: "GET",
          };
          const getStateCount = await dispatch(
            ApiCallWithLoader(stateRequestDetails)
          );
          const getDistrictCount = await dispatch(
            ApiCallWithLoader(districtRequestDetails)
          );
          setGbAdminCounts({
            stateCount: JSON.stringify(getStateCount?.payload?.total),
            districtCount: JSON.stringify(getDistrictCount?.payload?.total),
          });
        } catch (error) {
          dispatch(errorUpdate({ isError: true, error: error }));
        }
      };
      getCounts();
    }
    role === ROLE.ADMIN && fetchDistricts();
  }, []);

  //api call to get list of districts
  const fetchDistricts = async () => {
    const stateName =
      userDetails?.userDetails?.user_metadata?.address?.region.replace(
        / /g,
        "_"
      );
    const requestDetails = {
      url: API.DISTRICTS_BY_STATE.replace(":stateName", stateName),
      method: "GET",
    };
    const resp = await dispatch(ApiCallWithLoader(requestDetails));
    setDistrictList(
      resp.payload?.entry.map((location: any) => {
        return location.resource.name;
      })
    );
  };

  return (
    <>
      <Breadcrumbs
        active_key="my_profile"
        navigation={navigate}
        location={location.pathname}
      />
      <div className="container elsReset">
        <ProfilePictureDetails
          userName={
            getUserName(
              userDetails?.userDetails?.given_name,
              userDetails?.userDetails?.family_name
            ) ||
            userDetails?.userDetails?.nickname ||
            userDetails?.userDetails?.name ||
            ""
          }
          idDetails={` ${userDetails?.userDetails?.username}` || "0"}
          idType={"ID"}
          age={Utility.getAge(
            userDetails?.userDetails?.user_metadata?.birthdate
          )}
          birthOfDate={userDetails?.userDetails?.user_metadata?.birthdate || ""}
          phoneNumber={userDetails?.userDetails?.app_metadata?.phone_number.padStart(13, '+91')}
          userType={role}
          gender={""}
        />
        {(role === ROLE.GLOBAL_ADMIN || role === ROLE.GLOBAL_ADMIN_SUPPORT) && (
          <ProfileDetailsTranslations
            profileTitleKey="myProfile.number_state_district"
            contentData={getAddressContentData(role)}
          />
        )}
        {role === ROLE.ADMIN && (
          <ProfileDetailsTranslations
            profileTitleKey="state_and_disctricts"
            isStateAdmin={true}
            contentData={getAddressContentData(role)}
          />
        )}
        {role === ROLE.ASHA && (
          <>
            <ProfileDetailsTranslations
              profileTitleKey="myProfile.address"
              contentData={getAddressContentData(role)}
            />
            <ProfileDetailsTranslations
              profileTitleKey="myProfile.assign_location"
              contentData={getAssignLocationContentData(role)}
            />
          </>
        )}
        {role === ROLE.ANM && (
          <>
            <ProfileDetailsTranslations
              profileTitleKey="myProfile.address"
              contentData={getAddressContentData(role)}
            />
            <ProfileDetailsTranslations
              profileTitleKey="myProfile.assign_location"
              contentData={getAssignLocationContentData(role)}
            />
          </>
        )}
      </div>
    </>
  );
};

export default UserProfile;
